module.exports = __webpack_public_path__ + "static/media/stoneframe.62085a59.png";